<template>
    <div>
        <activity-modal v-if="isOpen" class="NotificationBar" :items="notifications" @close="close">
            <template slot="title">
                Notifikationer
            </template>

            <template slot="empty">
                Du har endnu ingen notifikationer.
            </template>

            <div slot="item" slot-scope="{ item }">
                <activity-modal-item
                    :avatar="item.creator ? item.creator.avatar_url : null"
                    :date="item.sent_at"
                    :icon="item.data.icon"
                    :title="item.creator ? item.creator.name : 'betterhype'"
                    :body="item.body_html"
                    :unread="item.read_at === null"
                    :action-text="item.data.actionText"
                    :action-url="item.data.actionUrl"
                >
                </activity-modal-item>
            </div>
        </activity-modal>

        <slot :open="open" :unread="unreadCount"></slot>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
</style>

<script type="text/babel">
import { ReplaySubject, combineLatest } from 'rxjs'
import ActivityModal from 'dashboard-js/components/ActivityModal'
import ActivityModalItem from 'dashboard-js/components/ActivityModalItem'
import CreatesPopovers from 'dashboard-js/mixins/CreatesPopovers'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import NotificationProvider from 'dashboard-js/providers/NotificationProvider'

export default {
    components: {
        ActivityModal,
        ActivityModalItem,
    },
    mixins: [CreatesPopovers, HasSubscriptions],

    data() {
        return {
            isOpenStream: new ReplaySubject(1),
            isOpen: false,
            unreadCount: 0,
            notifications: null,
        }
    },

    computed: {
        ready() {
            return this.notifications !== null
        },
    },

    mounted() {
        this.subscribe(NotificationProvider.notifications(), notifications => {
            this.onNotificationReceived(notifications)
            this.notifications = notifications
        })

        this.subscribe(NotificationProvider.unread(), unread => (this.unreadCount = unread.length))

        this.subscribe(this.isOpenStream, isOpen => {
            this.onToggledOpen(isOpen)
            this.isOpen = isOpen
        })

        this.subscribe(
            combineLatest(this.isOpenStream, NotificationProvider.unread()),
            ([isOpen, unread]) => {
                if (isOpen && unread.length && !Spark.impersonating) {
                    NotificationProvider.markAsRead()
                }
            }
        )
    },

    methods: {
        close() {
            this.isOpenStream.next(false)
        },

        open() {
            this.isOpenStream.next(true)
        },

        onNotificationReceived(notifications) {
            if (this.ready && !this.isOpen && notifications.length) {
                this.showPopover(notifications[0])
            }
        },

        onToggledOpen(isOpen) {
            if (isOpen) {
                this.destroyPopovers()
            }
        },

        showPopover(notification) {
            this.popover(this.$el, notification.body_text, {
                placement: 'bottom',
                container: '.MainMenu',
            })
        },
    },
}
</script>
